import React from 'react';
import PropTypes from 'prop-types';
import noop from './tools/noop';

const AllSelector = ({
  className = '',
  onSelectAll = noop,
  onDeSelectAll = noop,
  appContextType = '',
  onContextClick = noop,
}) => (
  <span className={className}>
    <span>Select:</span>
    <button type="button" className="highlighted-component all" onClick={onSelectAll}>all</button>
    <span>/</span>
    <button type="button" className="highlighted-component none" onClick={onDeSelectAll}>none</button>
    {appContextType !== '' && (
      <>
        <span>/</span>
        <button type="button" className="highlighted-component none" onClick={onContextClick}>{appContextType}</button>
      </>
    )}
  </span>
);

export default AllSelector;

AllSelector.propTypes = {
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  className: PropTypes.string,
  appContextType: PropTypes.string,
  onContextClick: PropTypes.func,
};
